// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3sUVr","title":"FrontImage_title__2dKJc"};